import { DrawerDialog, DrawerDialogProps } from '@/common/components/drawer-dialog';
import Spacer from '@/common/components/spacer';
import StatusBanner from '@/common/components/status-banner';
import PaymentAddressFormFragment, {
  PaymentAddressFormFragmentProps,
} from '@/form/components/payment-address-form-fragment';

import { getStandardCurrency } from '@/util-conversion/currency';
import { LoaderButton } from '@/common/components/loader-button';
import StripeCheckoutForm, {
  StripeConfig,
} from '@/checkout/components/stripe-checkout-form';

export interface UpdatePayOverdueBalanceDrawerDialogProps
  extends PaymentAddressFormFragmentProps,
    DrawerDialogProps {
  unpaidBalance: number;
  error?: string;
  shouldUseStripe?: boolean;
  stripeConfig?: StripeConfig;
}

export default function UpdatePayOverdueBalanceDrawerDialog({
  unpaidBalance,
  open,
  smartyStreetsEmbeddedKey,
  paymentError,
  error,
  addressErrors,
  handleClose,
  shouldUseStripe,
  stripeConfig,
}: UpdatePayOverdueBalanceDrawerDialogProps) {
  return (
    <DrawerDialog open={open} handleClose={handleClose} title={'Payment method'}>
      {error ? (
        <>
          <StatusBanner
            variant="error"
            message={{ text: error }}
            shouldScrollToTop={true}
          />
          <Spacer variant="height16" />
        </>
      ) : null}

      <StatusBanner
        variant="error"
        title={`Balance of ${getStandardCurrency(unpaidBalance)}`}
        message={{ text: 'Please update your payment method to pay your balance.' }}
      />
      <Spacer variant="height16" />
      <StripeCheckoutForm shouldUseStripe={shouldUseStripe} stripeConfig={stripeConfig}>
        <PaymentAddressFormFragment
          shouldUseStripe={shouldUseStripe}
          showCancellationBlurb={false}
          // Adyen props
          paymentError={paymentError}
          // Address props
          defaultAddress={undefined} // TODO: Pull in user's default address
          addressErrors={addressErrors}
          smartyStreetsEmbeddedKey={smartyStreetsEmbeddedKey}
        />
        <LoaderButton
          variant="primary"
          type="submit"
          name="intent"
          value="update-and-pay-overdue-balance"
          className="body-strong mt-4 w-full"
        >
          Update and pay balance
        </LoaderButton>
      </StripeCheckoutForm>
    </DrawerDialog>
  );
}
